/*
  index.jsx

  Entry point for the Botech editor component.
*/

// Npm.
import React from 'react';

// Components.
import RootApp from './components/RootApp';

/**
 * Botech online editor component.
 */
export default function BotechOnlineEditor(props) {
  return (
    <RootApp {...props} />
  );
}
